import React from 'react'
import Button from '../../components/Button/Button'
import toCamelCase from '../../function/toCamelCaseString'
function Quote(props) {
    const blockData = props?.quoteSection
    const { primaryColor, secondaryColor } = blockData?.bgColor
    return (
        <div className="relative z-10 ">
            <div className="container">
                <div
                    style={{
                        backgroundColor: `${secondaryColor || primaryColor}`,
                        backgroundImage: `url(${blockData?.bgImage?.sourceUrl})`,
                        backgroundRepeat: 'no-repeat'
                    }}
                    className="client-quote grid grid-cols-12 gap-x-2 text-white rounded-[30px] relative xl:gap-x-7"
                >
                    <div className="absolute top-7 right-5 w-32 md:w-52"></div>
                    <div className="col-span-10 col-start-2 py-10 md:py-20 xl:col-start-2  xl:pb-[80px] xl:pt-[80px] xl:pr-[40px]">
                        <h3 className="text-7xl leading-none xl:text-[100px]">
                            “
                        </h3>
                        <div className="mb-7 text-2xl font-[FoundersGrotesk-SemiBold]">
                            {blockData?.quote?.quoteText}
                        </div>

                        <p className="font-bold text-[17px] !mb-0">
                            {blockData?.quote?.author}
                        </p>
                        <span className="pre-header block mb-[29px]">
                            {blockData?.quote?.jobTitle}
                        </span>

                        {blockData?.buttons && (
                            <div className="flex items-center gap-x-[29px]">
                                {blockData?.buttons.map((button) => {
                                    if (!button) return null
                                    const { arrow, buttonType, buttonLink } =
                                        button
                                    return (
                                        <Button
                                            styles={toCamelCase(buttonType)}
                                            hasArrow={arrow}
                                            buttonLink={buttonLink}
                                        >
                                            {buttonLink?.title}
                                        </Button>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Quote
